import React from "react";
import * as styles from "./ValueStreamsSidePanel.module.scss";
import { Panel } from "cprime-foundational-components";
import { Stack } from "@mui/material";
import {
  createValueStream,
  getValueStreamsData,
} from "../../services/RequestAccess/RequestAccess";
import { triggerToast } from "../../utils/toast";

import Button from "../../Components/Common/CprimeButton";
interface ValueStreamSidePanelProps {
  open: boolean;
  appId?: string;
  onClose: () => void;
  BodyComponent: React.ReactNode;
  nameValueStream: any;
  descriptionValueStream: any;
  refreshData: any;
  setNameValueStream: Function;
  setDes: Function;
}

const ValueStreamSidePanel: React.FC<ValueStreamSidePanelProps> = ({
  open,
  onClose,
  BodyComponent,
  nameValueStream,
  descriptionValueStream,
  refreshData,
  setNameValueStream,
  setDes,
}) => {
  const scssClass = styles as any;
  const [loading, setLoading] = React.useState(false);

  const handleSave = async () => {
    try {
      const payload = {
        name: nameValueStream,
        description: descriptionValueStream,
      };
      setLoading(true);
      const response = await createValueStream(payload);
      const data = await getValueStreamsData();
      refreshData(data?.data);

      onClose();
      if (response?.error) {
        triggerToast(`${response?.error}`, "error");
      } else if (response?.status === true) {
        triggerToast(`${response?.message}`, "success");
      }
      triggerToast(`${response?.message}`, response?.status?.toLowerCase());
    } catch (err) {
      // console.error("Group save failed:", err);
    } finally {
      setLoading(false);
    }
    setNameValueStream("");
    setDes("");
  };

  return (
    <>
      <Panel
        id="valueStreamSidePanel"
        className={scssClass.userGroupMainPanel}
        sx={{
          "& .MuiDrawer-root": { padding: "0" },
          "& .MuiPaper-root": {
            width: "fit-content",
            minWidth: "800px",
            top: "104px",
            height: "calc(100vh - 104px)",
            gap: "24px",
          },
        }}
        open={open}
        title={"Create Value Stream"}
        side="right"
        onClose={onClose}
        body={
          <>
            {BodyComponent}
            <Stack
              direction="row"
              justifyContent="flex-end"
              textAlign="right"
              p="1rem 1.5rem 0rem 0rem"
              boxSizing="border-box"
              className={scssClass.footerButtons}
            >
              <Stack direction="row" gap={2}>
                <Button variant="tertiary" onClick={() => onClose()}>
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  disabled={
                    !nameValueStream?.trim() || !descriptionValueStream?.trim()
                  }
                  onClick={handleSave}
                  loading={loading}
                >
                  Create
                </Button>
              </Stack>
            </Stack>
          </>
        }
      />
      <span
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          position: "fixed",
          width: "100vw",
          height: "calc(100vh - 104px)",
          zIndex: 1100,
          top: "104px",
          left: 0,
        }}
      ></span>
    </>
  );
};

export default ValueStreamSidePanel;
